import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.array.for-each";
import _toConsumableArray from "/codebuild/output/src3036132009/src/www-public/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { CanvasContext } from '../../../../../types/dist/rrweb-types.js';
import { patch, isBlocked, hookSetter } from '../../../utils.js';
import { saveWebGLVar, serializeArgs } from './serialize-args.js';

function patchGLPrototype(prototype, type, cb, blockClass, blockSelector, mirror, win) {
  var handlers = [];
  var props = Object.getOwnPropertyNames(prototype);

  var _iterator = _createForOfIteratorHelper(props),
      _step;

  try {
    var _loop = function _loop() {
      var prop = _step.value;

      if (['isContextLost', 'canvas', 'drawingBufferWidth', 'drawingBufferHeight'].includes(prop)) {
        return "continue";
      }

      try {
        if (typeof prototype[prop] !== 'function') {
          return "continue";
        }

        var restoreHandler = patch(prototype, prop, function (original) {
          return function () {
            for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }

            var result = original.apply(this, args);
            saveWebGLVar(result, win, this);

            if ('tagName' in this.canvas && !isBlocked(this.canvas, blockClass, blockSelector, true)) {
              var recordArgs = serializeArgs([].concat(args), win, this);
              var mutation = {
                type: type,
                property: prop,
                args: recordArgs
              };
              cb(this.canvas, mutation);
            }

            return result;
          };
        });
        handlers.push(restoreHandler);
      } catch (_a) {
        var hookHandler = hookSetter(prototype, prop, {
          set: function set(v) {
            cb(this.canvas, {
              type: type,
              property: prop,
              args: [v],
              setter: true
            });
          }
        });
        handlers.push(hookHandler);
      }
    };

    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _ret = _loop();

      if (_ret === "continue") continue;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return handlers;
}

function initCanvasWebGLMutationObserver(cb, win, blockClass, blockSelector, mirror) {
  var handlers = [];
  handlers.push.apply(handlers, _toConsumableArray(patchGLPrototype(win.WebGLRenderingContext.prototype, CanvasContext.WebGL, cb, blockClass, blockSelector, mirror, win)));

  if (typeof win.WebGL2RenderingContext !== 'undefined') {
    handlers.push.apply(handlers, _toConsumableArray(patchGLPrototype(win.WebGL2RenderingContext.prototype, CanvasContext.WebGL2, cb, blockClass, blockSelector, mirror, win)));
  }

  return function () {
    handlers.forEach(function (h) {
      return h();
    });
  };
}

export { initCanvasWebGLMutationObserver as default };